// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1uzAx","messages":"Chat_messages__1n9U8","dateDivider":"Chat_dateDivider__1pxm0"};